import { ROLES, ROUTE_STRING } from "./constant";

// utils/routes.js
const routes = {
  superadmin: {
    [`/${ROUTE_STRING.CORPORATES}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CAMPUS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.STUDENTS}/${ROUTE_STRING.ON_CAMPUS_STUDENT}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.STUDENTS}/${ROUTE_STRING.OFF_CAMPUS_STUDENT}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.PENDINGREVIEW}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CORPORATE_PLANING}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CAMPUS_PLANING}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.SUPER_ADMIN_PAYMENT}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.SLIDERS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.NEWS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.COUPON}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.TESTS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ADDQUESTION}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ADDQUESTION}/${ROUTE_STRING.QUESTION}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.TEST_INVITATION}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ASSESSMENT}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_SEND}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_RECEIVED}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_STUDENT_SEND}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_SEND}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_RECEIVED}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_STUDENT_SEND}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.STUDENTINVITATION}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.HIRINGPROCESS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.INTERVIEW_PANEL}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.GUEST_LOGS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ANALYTICS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CLIENTSUPPORT}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.SUPPORT_TICKET_TYPE}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.SUPPORT_FAQS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ETALKS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.LATESTUPDATES}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.LIVECAMPUS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.WEBSITE_QUERY}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.DEMO_QUERY}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.BLOGS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.SUPPORTS_LIST}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.COLLAGEUNIVERSITY}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_SEND}/${ROUTE_STRING.REPORTS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_RECEIVED}/${ROUTE_STRING.REPORTS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_SEND}/${ROUTE_STRING.REPORTS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_RECEIVED}/${ROUTE_STRING.REPORTS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ADDRESS}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ADDRESS}/${ROUTE_STRING.REGION}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ADDRESS}/${ROUTE_STRING.REGION}/${ROUTE_STRING.STATE}`]: [ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.ADDRESS}/${ROUTE_STRING.REGION}/${ROUTE_STRING.STATE}/${ROUTE_STRING.DISTRICT}`]: [ROLES.SUPER_ADMIN],

  },
  campus: {
    [`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.REGISTEREDCORPORATES}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.REGISTEREDSTUDENTS}`]: [ ROLES.CAMPUS],
    [`/${ROUTE_STRING.PENDING_APPROVALS}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_SEND}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_RECEIVED}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_STUDENT_SEND}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.CORPORATE_PLANING}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.CORPORATE_PLANING}/${ROUTE_STRING.SEND_PLANING_DETAILS}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_SEND}/${ROUTE_STRING.REPORTS}`]: [ROLES.CAMPUS],
    [`/${ROUTE_STRING.CAMPUS_INVITATION_RECEIVED}/${ROUTE_STRING.REPORTS}`]: [ROLES.CAMPUS],
  },
  corporate: {
    [`/${ROUTE_STRING.PROFILE_UPDATE_CORPORATE}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.REGISTEREDCAMPUS}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.STUDENTS}/${ROUTE_STRING.ON_CAMPUS_STUDENT}`]: [ ROLES.CORPORATE],
    // [`/${ROUTE_STRING.STUDENTS}/${ROUTE_STRING.OFF_CAMPUS_STUDENT}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.INTERVIEW_PANEL}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.ASSESSMENT}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.TESTS}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.ADDQUESTION}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.ADDQUESTION}/${ROUTE_STRING.QUESTION}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.HIRINGPROCESS}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.HIRINGPROCESS}/${ROUTE_STRING.ADD_HIRINGPROCESS}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.CAMPUS_PLANING}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.CAMPUS_PLANING}/${ROUTE_STRING.SEND_PLANING_DETAILS}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.TEST_INVITATION}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_SEND}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_RECEIVED}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_STUDENT_SEND}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.FINAL_INTERVIEW}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.FINAL_SELECTION}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.FINAL_SELECTION}/${ROUTE_STRING.PERSIONALINTERVIEW_STUDENT_LIST}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_SEND}/${ROUTE_STRING.REPORTS}`]: [ROLES.CORPORATE],
    [`/${ROUTE_STRING.CORPORATE_INVITATION_RECEIVED}/${ROUTE_STRING.REPORTS}`]: [ROLES.CORPORATE],
  },
  student: {
    [`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`]: [ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.STUDENT_REVIEW_FORM}`]: [ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.RECEIVE_STUDENT_INVITATION}`]: [ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.ONLINE_TEST_ASSESSMENT}`]: [ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.INTERVIEW_SCHEDULE}`]: [ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.INTERVIEW_CALL}`]: [ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
  },
  interviewer: {
    [`/${ROUTE_STRING.UPCOMMING_INTERVIEWES}`]: [ROLES.INTERVIEWER],
    [`/${ROUTE_STRING.COMPLITED_INTERVIEWES}`]: [ROLES.INTERVIEWER],
    [`/${ROUTE_STRING.MISSED_INTERVIEWES}`]: [ROLES.INTERVIEWER],
  },
  common: {
    [`/${ROUTE_STRING.DASHBOARD}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT, ROLES.SUPER_ADMIN ,ROLES.INTERVIEWER],
    [`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT, ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.PRESENTATION}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.OFFERLETTER}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT, ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.DEPARTMENT}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.COURSE}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.BRANCH}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.DESIGNATION}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.SCHEDULE}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.NOTIFICATION}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT, ROLES.SUPER_ADMIN],
    [`/${ROUTE_STRING.SUPPORT}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.SUPPORTTICKET}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.PAYMENT}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
    [`/${ROUTE_STRING.BILLING}`]: [ROLES.CAMPUS, ROLES.CORPORATE, ROLES.ON_STUDENT, ROLES.OFF_STUDENT],
  },
};

export default routes;
